import { observer } from 'mobx-react-lite'
import React from 'react'
import MediaAction from './MediaAction'

export default observer(function MediaActions({ actions, campaignScenario }) {

  return (
    <div className="p-3 text-xs overflow-x-auto">
      <table className="border border-border-primary dark:border-rb-dark-mode-lighter">
        <thead>
          <tr className="bg-gray-200 dark:bg-rb-dark-mode-lighter">
            <td className="py-3 px-1 text-xs min-w-[150px] dark:text-white"></td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[150px] dark:text-white">Inf. Pay Out Price</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[90px] dark:text-white">Inf. Price</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[150px] dark:text-white">Adv. Price with KSA</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">CPM (Follower)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">CPM (Imprs.)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Impression</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[70px] dark:text-white">Buyout</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[120px] dark:text-white">Inf. Buyout Price</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[120px] dark:text-white">Buyout Adv. Price</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[130px] dark:text-white">KSA Tax Total</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Inf. Margin (%)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Inf. Margin Total</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Adv. Margin (%)</td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal min-w-[100px] dark:text-white">Adv. Margin Total</td>
          </tr>
        </thead>
        <tbody>
          { actions.map(action => <MediaAction key={action.id} action={action} campaignScenario={campaignScenario} />)}
        </tbody>
      </table>
    </div>
  )
})